import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * LeaveRequest class for mapping form data to leave request structure
 * Maps raw form submission data to the expected table format
 */
var LeaveRequest = /*#__PURE__*/function () {
  function LeaveRequest(form) {
    var leaveRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, LeaveRequest);
    this.data = form;
    this.leaveRequestData = leaveRequest;
    this.student = null; // Initialize student property
    this.mapData();
  }

  /**
   * Maps raw form data to expected leave request structure
   */
  return _createClass(LeaveRequest, [{
    key: "mapData",
    value: function mapData() {
      var form = this.data;
      var leaveReq = this.leaveRequestData;
      console.log('Mapping LeaveRequest with form:', form, 'and leaveReq:', leaveReq);
      // Use leave-request data if available, otherwise fall back to form data
      // Basic mapping from raw form data
      this.id = leaveReq.id;
      this.status = this.mapStatus(leaveReq.status);
      this.receivedDate = leaveReq.created;
      this.decisionSent = (form === null || form === void 0 ? void 0 : form.decisionSent) || false;
      this.startDate = leaveReq.startDate;
      this.endDate = leaveReq.endDate;
      this.student = this.mapUser(leaveReq.student);
      this.formId = (leaveReq === null || leaveReq === void 0 ? void 0 : leaveReq.formId) || form.id;
      this.decision = leaveReq === null || leaveReq === void 0 ? void 0 : leaveReq.status;
      this.decisionComment = leaveReq === null || leaveReq === void 0 ? void 0 : leaveReq.decisionComment;
      if (form != null) {
        // Extract data from submitted leave request instance for dates and reason
        var submittedInstance = this.getSubmittedLeaveRequestInstance(form.formInstances);
        if (submittedInstance) {
          var _submittedInstance$fo;
          console.log('Submitted Instance:', submittedInstance);
          // Extract dates and reason from field results using template
          var fieldData = this.extractRequestFieldData(submittedInstance.fieldResults, (_submittedInstance$fo = submittedInstance.formTemplate) === null || _submittedInstance$fo === void 0 ? void 0 : _submittedInstance$fo.fields);
          this.reason = fieldData.reason;
          this.student = this.mapUser(submittedInstance.student);
          this.createdBy = this.mapUser(submittedInstance.user);
          console.log('Mapped Student:', this.createdBy);
        }
      }
    }

    /**
     * Maps status from various formats to standardized English format
     * Returns English keys that should be translated in the component
     */
  }, {
    key: "mapStatus",
    value: function mapStatus(status) {
      if (!status) return 'Pending decision';
      var normalizedStatus = (status || '').toString().toLowerCase().trim();
      if (normalizedStatus.includes('pending')) {
        return 'Pending decision';
      }
      if (normalizedStatus.includes('approved')) {
        return 'Approved';
      }
      if (normalizedStatus.includes('rejected')) {
        return 'Rejected';
      }
      if (normalizedStatus.includes('revoked')) {
        return 'Withdrawn';
      }
      return status;
    }

    /**
     * Maps student/user information to expected format
     */
  }, {
    key: "mapUser",
    value: function mapUser(userData) {
      if (!userData) return null;
      console.log(userData);
      // Check if user data has actual values or just nulls
      if (userData.firstName === null && userData.lastName === null && userData.displayName === null && userData.userName === null) {
        return null; // No actual user data available
      }
      return {
        firstName: userData.firstName || userData.givenName || userData.displayName || '',
        lastName: userData.lastName || userData.familyName || userData.surname || ''
      };
    }

    /**
     * Gets a submitted form instance by template type from formInstances array
     * @param {Array} formInstances - Array of form instances to search through
     * @param {string} templateType - The form template type to search for (e.g., 'LEAVE_REQUEST', 'LEAVE_RESPONSE')
     * @returns {Object|null} The submitted instance matching the template type or null if not found
     */
  }, {
    key: "getSubmittedFormInstanceByType",
    value: function getSubmittedFormInstanceByType(formInstances, templateType) {
      if (!Array.isArray(formInstances)) return null;

      // Find the instance with status "SUBMITTED" and matching template type
      return formInstances.find(function (instance) {
        var _instance$formTemplat;
        var hasCorrectType = ((_instance$formTemplat = instance.formTemplate) === null || _instance$formTemplat === void 0 ? void 0 : _instance$formTemplat.type) == templateType;
        var isSubmitted = instance.status == 'SUBMITTED';
        return hasCorrectType && isSubmitted;
      }) || null;
    }

    /**
     * Gets the submitted leave request instance (from the requester/student)
     */
  }, {
    key: "getSubmittedLeaveRequestInstance",
    value: function getSubmittedLeaveRequestInstance(formInstances) {
      return this.getSubmittedFormInstanceByType(formInstances, 'LEAVE_REQUEST');
    }

    /**
     * Gets the submitted leave response instance (from the responder/decision maker)
     */
  }, {
    key: "getSubmittedLeaveResponseInstance",
    value: function getSubmittedLeaveResponseInstance(formInstances) {
      return this.getSubmittedFormInstanceByType(formInstances, 'LEAVE_RESPONSE');
    }

    /**
     * Extracts field data from leave request fieldResults array using FormTemplate fields
     * Automatically identifies fields based on their types
     */
  }, {
    key: "extractRequestFieldData",
    value: function extractRequestFieldData(fieldResults, templateFields) {
      var startDate = null;
      var endDate = null;
      var reason = '';
      if (!Array.isArray(fieldResults) || !Array.isArray(templateFields)) {
        return {
          startDate: startDate,
          endDate: endDate,
          reason: reason
        };
      }

      // Find the date range field (FIELDS_START_END_INPUTS type)
      var dateRangeField = templateFields.find(function (field) {
        return field.type === 'FIELDS_START_END_INPUTS';
      });
      if (dateRangeField) {
        var dateResult = fieldResults.find(function (r) {
          return r.fieldName === dateRangeField.name;
        });
        if (dateResult !== null && dateResult !== void 0 && dateResult.value) {
          // Value might be a JSON string or object with start/end dates
          var dateValue = typeof dateResult.value === 'string' ? JSON.parse(dateResult.value) : dateResult.value;
          startDate = (dateValue === null || dateValue === void 0 ? void 0 : dateValue.start) || null;
          endDate = (dateValue === null || dateValue === void 0 ? void 0 : dateValue.end) || null;
        }
      }

      // Find the reason/text field (FIELDS_INPUT_TEXTAREA type)
      var textAreaField = templateFields.find(function (field) {
        return field.type === 'FIELDS_INPUT_TEXTAREA';
      });
      if (textAreaField) {
        var reasonResult = fieldResults.find(function (r) {
          return r.fieldName === textAreaField.name;
        });
        reason = (reasonResult === null || reasonResult === void 0 ? void 0 : reasonResult.value) || '';
      }
      return {
        startDate: startDate,
        endDate: endDate,
        reason: reason
      };
    }

    /**
     * Extracts decision field data from leave response fieldResults array using FormTemplate fields
     * Automatically identifies decision and comment fields based on their types
     */
  }, {
    key: "extractDecisionFieldData",
    value: function extractDecisionFieldData(fieldResults, templateFields) {
      var decision = null;
      var comment = '';
      if (!Array.isArray(fieldResults) || !Array.isArray(templateFields)) {
        return {
          decision: decision,
          comment: comment
        };
      }

      // Find the decision field (FIELDS_INPUT_DECISION_RADIOGROUP type)
      var decisionField = templateFields.find(function (field) {
        return field.type === 'FIELDS_INPUT_DECISION_RADIOGROUP';
      });
      if (decisionField) {
        var decisionResult = fieldResults.find(function (r) {
          return r.fieldName === decisionField.name;
        });
        decision = (decisionResult === null || decisionResult === void 0 ? void 0 : decisionResult.value) || null;
      }

      // Find the comment/text field (FIELDS_INPUT_TEXTAREA type)
      var textAreaField = templateFields.find(function (field) {
        return field.type === 'FIELDS_INPUT_TEXTAREA';
      });
      if (textAreaField) {
        var commentResult = fieldResults.find(function (r) {
          return r.fieldName === textAreaField.name;
        });
        comment = (commentResult === null || commentResult === void 0 ? void 0 : commentResult.value) || '';
      }
      return {
        decision: decision,
        comment: comment
      };
    }

    /**
     * Returns the leave request data in table row format
     */
  }, {
    key: "toTableRow",
    value: function toTableRow() {
      return {
        id: this.id,
        formId: this.formId,
        student: this.student,
        // Object with firstName, lastName
        receivedDate: this.receivedDate,
        startDate: this.startDate,
        startTime: this.startDate,
        status: this.status,
        decisionSent: this.decisionSent,
        createdBy: this.createdBy,
        endDate: this.endDate,
        endTime: this.endDate,
        reason: this.reason,
        decision: this.decision,
        decisionComment: this.decisionComment,
        decisionBy: this.decisionBy,
        decisionDate: this.decisionDate,
        decisionFormFields: this.decisionFormFields,
        noteFields: this.noteFields
      };
    }

    /**
     * Map leaveRequests array together with raw forms array.
     * Only returns forms that exist in rawForms and are referenced by a leaveRequest (by formId/FormId).
     * @param {Array} leaveRequests - array of leave request objects that reference forms (has formId or FormId)
     */
  }], [{
    key: "toTableRows",
    value: function toTableRows() {
      var leaveRequests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (!Array.isArray(leaveRequests)) return [];
      return leaveRequests.filter(function (request) {
        return request != null;
      }).map(function (request) {
        return new LeaveRequest(null, request).toTableRow();
      });
    }

    /**
     * Extracts the decision value from form field results
     * @param {Array} fieldResults - Array of field result objects from the decision form
     * @param {Array} templateFields - Array of field definitions from the form template
     * @returns {string|null} The decision value or null if not found
     */
  }, {
    key: "extractDecisionValue",
    value: function extractDecisionValue(fieldResults, templateFields) {
      if (!Array.isArray(fieldResults) || !Array.isArray(templateFields)) {
        return null;
      }

      // Find the decision field (radio group field)
      var decisionField = fieldResults.find(function (field) {
        return templateFields.some(function (f) {
          return f.name === field.fieldName && f.type === 'FIELDS_INPUT_DECISION_RADIOGROUP';
        });
      });

      // Guard: decisionField may be undefined, and decisionField.value may be undefined
      if (!decisionField || decisionField.value == null) return null;
      try {
        return String(decisionField.value).toUpperCase();
      } catch (e) {
        return null;
      }
    }

    /**
     * Maps a decision value to a form status
     * @param {string} decision - The decision value from the form
     * @returns {string} The mapped form status ('approved', 'rejected', or 'pending')
     */
  }, {
    key: "mapDecisionToFormStatus",
    value: function mapDecisionToFormStatus(decision) {
      if (!decision) return 'PENDING';
      var normalizedDecision = decision.toLowerCase();

      // Check for approved variants
      if (normalizedDecision.includes('approved')) {
        return 'APPROVED';
      }

      // Check for rejected/denied variants
      if (normalizedDecision.includes('denied')) {
        return 'REJECTED';
      }

      // Default to pending
      return 'PENDING';
    }
  }]);
}();
export default LeaveRequest;